;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import {
  Tracker,
  TrackingEventList,
  TrackingEventName,
  TrackingEventProperties,
} from './types'

type TrackingEventHandler<
  TEventList extends TrackingEventList,
  TEventName extends TrackingEventName<TEventList>,
> = (
  event: TEventName,
  properties: TrackingEventProperties<TEventList, TEventName>,
) => void

type TrackingEventHandlerMap<TEventList extends TrackingEventList> = {
  [TEventName in TrackingEventName<TEventList>]?: TrackingEventHandler<
    TEventList,
    TEventName
  >
}

/**
 * A tracking destination handles tracking events for a specific platform or service. E.g. Segment, Google Analytics, etc.
 * and defines what events are supported and how to track them.
 *
 * @example
 * ```ts
 * // A default event handler can be provided to handle all events that are not explicitly defined.
 * const segmentTrackingDestination = new TrackingDestination({
 *   defaultEventHandler: (event, properties) => analytics.track(event, properties)
 * })
 *
 * // An event handler can be provided for a specific event.
 * const gtagTrackingDestination = new TrackingDestination({
 *   eventHandlers: {
 *     'Sign Up': (event, properties) => window.gtag('event', event, properties)
 *   },
 * })
 * ```
 */
export class TrackingDestination<
  TEventList extends TrackingEventList,
> implements Tracker<TEventList> {
  #eventHandlers: TrackingEventHandlerMap<TEventList>
  #defaultEventHandler?: TrackingEventHandler<TEventList, keyof TEventList>

  constructor({
    eventHandlers = {},
    defaultEventHandler,
  }: {
    /**
     * Use eventHandlers to handle specific events.
     */
    eventHandlers?: TrackingEventHandlerMap<TEventList>
    /**
     * Use defaultEventHandler to handle all events that are not explicitly defined.
     */
    defaultEventHandler?: TrackingEventHandler<TEventList, keyof TEventList>
  }) {
    this.#eventHandlers = eventHandlers
    this.#defaultEventHandler = defaultEventHandler
  }

  track<TEventName extends TrackingEventName<TEventList>>(
    event: TEventName,
    properties: TrackingEventProperties<TEventList, TEventName>,
  ) {
    const eventHandler = this.#eventHandlers[event]
    if (eventHandler) {
      return eventHandler(event, properties)
    }
    if (this.#defaultEventHandler) {
      return this.#defaultEventHandler(event, properties)
    }
  }
}
